import { useMediaQuery } from "@afas-doe-maar/ui/useMediaQuery";
import { cn } from "@afas-doe-maar/ui/utils";

interface ScreenWrapperProps {
  children: React.ReactNode;
  size?: "default" | "mobile";
}

export function ScreenWrapper({ children, size = "default" }: ScreenWrapperProps) {
  const isBigScreen = useMediaQuery("(min-width: 768px) or (min-height: 1024px)");

  return (
    <div
      className={cn(
        "grid h-dvh w-dvw place-items-center overflow-clip bg-neutral-900 text-base select-none",
        isBigScreen && "p-4",
      )}
    >
      <main
        className={cn(
          // The `screen` class is here for mounted components to be able to find it's container
          "screen bg-background h-full w-full max-w-[768px] overflow-y-scroll shadow-lg",
          size === "default" && "max-h-[1024px] max-w-[768px]",
          size === "mobile" && "h-[667px] w-[375px]",
        )}
      >
        {children}
      </main>
    </div>
  );
}
